import React from 'react'
import Image from '../../../images/sellerpolicies/20.png'

const Shipping_and_order_fulfilment = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Shipping and Order Fulfilment:</h2>
            <p>Seller shall remain the sole and undisputed owner of the sold Product(s) until it is successfully delivered to the Customer, at which point title and ownership shall be transferred to the Customer. In case any Product is returned or rejected by a Customer, the title and ownership of the Product shall, immediately upon return or rejection, revert to the Seller who shall be the sole and undisputed owner of the Product.</p>
            <p>Seller shall solely be responsible for the dispatch and delivery of any sold Product(s) to the Customer in accordance with the rules of packaging and shipping as contained within this agreement and relevant Platform Policies.</p>
        </div>
      </div>
    </div>
  )
}

export default Shipping_and_order_fulfilment
